import * as React from 'react';
import Box from '@mui/material/Box';
import { columns, generateRows } from './partials';
import { Table } from '@organisms';
import { callGetCoreContacts } from '@api';
import { useState, useContext } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { TableContext } from '@particles';
import { Alert } from '@atoms';

export interface CoreContactsProps {
  locationId: string;
  refreshTrigger?: number;
}

const CoreContacts: React.FC<CoreContactsProps> = ({
  locationId,
  refreshTrigger = 0
}) => {
  const {
    state: {
      coreContactsPagination: { page, perPage, orderBy }
    }
  } = useContext(TableContext);

  const [error] = useState<string>();

  const contactsQuery = useQuery({
    queryKey: ['core-contacts', locationId, page, perPage, orderBy, refreshTrigger],
    queryFn: () => callGetCoreContacts({ locationId, pageNumber: page, pageSize: perPage, sortBy: orderBy }),
    placeholderData: keepPreviousData
  });

  const data: Pagination<CoreContact> | undefined =
    contactsQuery.data?.code === 200 ? contactsQuery.data.data : undefined;
  const loading = contactsQuery.isFetching;
  const rowData: TableRow[] = data ? generateRows(data.data) : [];

  return (
    <Box>
      {error && (
        <Box sx={{ mb: 1 }}>
          <Alert message={error} severity={'error'} />
        </Box>
      )}

      <Table
        name="core_contacts"
        columns={columns}
        data={rowData}
        isLoading={loading}
        pagination={data}
        persistColumnPrefs
      />
    </Box>
  );
};

export default CoreContacts;
